var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99983 5.00149C6.1173 4.66757 6.34915 4.386 6.65432 4.20665C6.95949 4.0273 7.3183 3.96174 7.66718 4.02158C8.01606 4.08142 8.3325 4.2628 8.56046 4.5336C8.78842 4.8044 8.91319 5.14714 8.91266 5.50112C8.91266 6.50037 7.41378 7 7.41378 7M7.4331 9H7.43977M7.33316 12.3333C10.4628 12.3333 12.9998 9.79628 12.9998 6.66667C12.9998 3.53705 10.4628 1 7.33316 1C4.20355 1 1.6665 3.53705 1.6665 6.66667C1.6665 7.3 1.7704 7.90906 1.96208 8.47774C2.03421 8.69175 2.07028 8.79875 2.07678 8.88095C2.08321 8.96213 2.07835 9.01905 2.05827 9.09797C2.03793 9.17788 1.99303 9.26099 1.90323 9.42721L0.812789 11.4456C0.657248 11.7335 0.579478 11.8774 0.596883 11.9885C0.612044 12.0853 0.668996 12.1705 0.752614 12.2215C0.848616 12.2801 1.01136 12.2632 1.33686 12.2296L4.75087 11.8767C4.85426 11.866 4.90595 11.8606 4.95307 11.8624C4.99941 11.8642 5.03213 11.8686 5.07732 11.879C5.12327 11.8896 5.18104 11.9118 5.2966 11.9564C5.92864 12.1999 6.61531 12.3333 7.33316 12.3333Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizIcon);
export default __webpack_public_path__ + "static/media/quiz_icon.5e138837e04a0f02e74465ad32c4be14.svg";
export { ForwardRef as ReactComponent };